import React, { useState } from "react";
import CardDiv from "modules/common/card-div/CardDiv";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import { UploadOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import { Upload } from "antd";
import { useUpdateWarehousePincode } from "modules/order_management/store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { validateEmail } from "modules/utilities/utility";

function WarehousePincodeMapping() {
  const [fileData, setFileData] = useState({});
  const [fileListArray, setFileListArray] = useState([]);
  const { updateWarehousePincode, downloadData } = useUpdateWarehousePincode();
  const { setToaster } = useToast();
  const [email, setEmail] = useState(null);

  const handleUpload = () => {
    let file = new FormData();
    file.append("file", fileData);
    updateWarehousePincode(file, setToaster);
    setFileData([]);
    setFileListArray([]);
  };

  const beforeUpload = (file) => {
    if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
      message.error(`only csv file allowed`, 2);
      return true;
    }
    return false;
  };

  const handleFileUpload = (info) => {
    if (info.fileList.length !== 0) {
      setFileListArray(info.fileList);
      setFileData(info.file);
    }
  };

  const resetFile = () => {
    setFileListArray([]);
    setFileData({});
  };

  const downloadWarehouseData =()=>{
    downloadData(email, setToaster);
  }

  return (
    <div>
      <CardDiv
        title={<div className="fs-2 ">Update Warehouse Pincode</div>}
        component={
          <div className="text-center" style={{ height: "20rem" }}>
            <div className="flex gap-2">
              <div className="my-3 w-50 m-auto">
                <InputGroup className="mb-3">
                  <InputGroup.Text id="inputGroup-sizing-default">
                    <span className="fw-bold"> Email</span>
                  </InputGroup.Text>
                  <FormControl
                    aria-label="Default"
                    aria-describedby="inputGroup-sizing-default"
                    onChange={(e) => setEmail(e.target.value)}
                    isInvalid={!validateEmail(email)}
                  />
                  <button className={`btn btn-primary${!validateEmail(email) ? ' disabled' : ''}`} onClick={downloadWarehouseData}>Download</button>

                </InputGroup>
                {(!validateEmail(email)&&email?.length)?<div className="text-danger fw-bold">Please Enter valid Email</div>:null}
              </div>
              <Upload
                name="file"
                accept=".csv"
                className="mt-4 text-center"
                beforeUpload={(file) => beforeUpload(file)}
                onChange={handleFileUpload}
                maxCount={1}
                onRemove={resetFile}
                fileList={fileListArray}
              >
                <Button
                  className="btn btn-primary-outline"
                  type
                  icon={<UploadOutlined />}
                >
                  Add File
                </Button>
              </Upload>
            </div>
            <div className="fw-bold mt-3">Add CSV File</div>
            <Button
              className="w-max mt-4"
              disabled={isEmpty(fileData)}
              onClick={handleUpload}
              type="primary"
            >
              Upload
            </Button>
          </div>
        }
      />
    </div>
  );
}

export default WarehousePincodeMapping;
